import React, {useRef, useState} from "react";
import {ApiUrl} from "../utils/portal-urls";
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Input,
    InputLabel,
    MenuItem,
    Select,
    styled,
    TextareaAutosize,
    Typography
} from "@mui/material";
import {handleHttpResponse} from "../utils/http-helpers";
import {CustomBackdrop} from "../utils/customStyles";
import ShowSnackbar from "../utils/ShowSnackbar";
import Box from "@mui/material/Box";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import {Transition} from "../users/OrganizationUserAddDialog";


const StyledTypography = styled(Typography)({
    marginTop: '8px',
    marginBottom: '12px',
    fontWeight: 'bold'
})
const StyledBox = styled(Box)(({theme}) => ({
    padding: theme.spacing(1),
    margin: '10px 0',
    borderRadius: 5,
    borderStyle: 'solid',
    borderWidth: 0.5,
    borderColor: '#777777'

}))
const PEM_CERT_BEGIN = "-----BEGIN CERTIFICATE-----";
const PEM_CERT_END = "-----END CERTIFICATE-----";

export default function HispsAssignCertDialog(props) {

    const setAssignCertDialogOpen = props.setAssignCertDialogOpen;
    const assignCertDialogOpen = props.assignCertDialogOpen;
    const hisps = props.hispsResult || [];
    const setRefresh = props.setRefresh;

    const [loading, setLoading] = useState(false)
    const [selectedHisp, setSelectedHisp] = useState("");
    const [selectedHispId, setSelectedHispId] = useState("");
    const [cert, setCert] = useState("");
    const [isValidCert, setIsValidCert] = useState({});
    const [msg, setMsg] = useState("");
    const [snackbarMsg, setSnackbarMsg] = useState({open: false, msg: '', msgLv: ''});
    const [selectedFile, setSelectedFile] = useState();
    const [isFileSelected, setIsFileSelected] = useState(false);

    const handleClose = () => {
        setAssignCertDialogOpen(false);
        setMsg("");
    };

    const handleUpload = (event) => {
        event.preventDefault();

        if (!isFileSelected && !isValidCert.valid) {
            // setMsg(`Invalid PEM encoded X509 certificate. A PEM encoded X509 certificate starts with ${PEM_CERT_BEGIN}, ends with ${PEM_CERT_END}`);
            setMsg("Please select a file to upload or check the format of the PEM encoded");
            return;
        }

        if (!selectedHisp) {
            setMsg(`Please select a HISP`);
            return;
        }
        handleUploadClose();

        if (isFileSelected) {
            uploadWithFile();
        } else if (isValidCert) {
            uploadWithPemEncoded()
        }
    }

    const uploadWithPemEncoded = async () => {
        if (!isValidCert.valid) {
            setMsg(`Invalid PEM encoded X509 certificate. A PEM encoded X509 certificate starts with ${PEM_CERT_BEGIN}, ends with ${PEM_CERT_END}`);
            return;
        }

        const url = ApiUrl.Hisps.assignCert.getPath(selectedHispId);
        const requestOption = {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: isValidCert.cert
        }
        console.log(isValidCert.cert)
        console.info(requestOption);

        try {
            setLoading(true);
            const res = await fetch(url, requestOption);
            const data = await handleHttpResponse(res);
            console.log(data);
            setSnackbarMsg({open: true, msg: `Successfully upload certificate to ${selectedHisp}`, msgLv: 'success'});
            setRefresh(new Date().getTime());
            setSelectedHispId("");
            setSelectedHisp("");
            setIsValidCert({})
            setCert("")
        } catch (err) {
            console.error("Failed to POST to server, ", err);
            setSnackbarMsg({open: true, msg: `Failed to assign the certificate to ${selectedHisp}`, msgLv: 'error'});
        } finally {
            setMsg("");
            setLoading(false);
        }
    }

    const uploadWithFile = async () => {
        if (selectedFile === null || selectedFile === undefined) {
            setSnackbarMsg({open: true, msg: `Please select a file`, msgLv: 'warning'});
            return;
        }

        const url = ApiUrl.Hisps.assignCertWithFile.getPath(selectedHispId);
        const requestOption = {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: selectedFile
        }
        console.log(`POST ${url} with request option:`)
        console.log(requestOption);

        try {
            setLoading(true);
            const res = await fetch(url, requestOption);
            const data = await handleHttpResponse(res);
            console.log(data);
            setSnackbarMsg({open: true, msg: `Successfully upload certificate file to ${selectedHisp}`, msgLv: 'success'});
            setSelectedHispId("");
            setSelectedHisp("");
            setIsFileSelected(false);
            setSelectedFile(null);
            setRefresh(new Date().getTime());
        } catch (err) {
            console.error("Failed to upload the file, " + selectedFile)
            setSnackbarMsg({open: true, msg: `Failed to upload the file to ${selectedHisp}`, msgLv: 'error'});
        } finally {
            setLoading(false);
            setMsg("");
        }

    }

    const handleHispChange = (event) => {
        const value = event.target.value;
        setSelectedHisp(value);
    };

    const handleUploadClose = () => {
        if (!isFileSelected && !isValidCert.valid) {
            setMsg(`Invalid PEM encoded X509 certificate. A PEM encoded X509 certificate starts with ${PEM_CERT_BEGIN}, ends with ${PEM_CERT_END}`);
            return;

        } else if (!selectedHisp) {
            setMsg('Please Select A HISP');
            return;
        }

        setAssignCertDialogOpen(false);

    }

    const handleCertChange = (event) => {
        const value = event.target.value;
        const validCert = verifyCertificate(value);
        setCert(value);

        if (validCert) {
            setIsValidCert({...isValidCert, valid: true, cert: validCert});
        } else if (value === '' || value === null) {
            setIsValidCert({...isValidCert, valid: false})
            setMsg("")
        } else {
            setIsValidCert({...isValidCert, valid: false});
        }

    }

    const verifyCertificate = (value) => {
        let validCert = "";

        let beginIndex = value.indexOf(PEM_CERT_BEGIN);
        if (beginIndex === false || beginIndex === -1) {
            setMsg(`Invalid PEM encoded X509 certificate. A PEM encoded X509 certificate starts with ${PEM_CERT_BEGIN}, ends with ${PEM_CERT_END}`);
            return;
        } else {
            let endIndex = value.indexOf(PEM_CERT_END);
            if (endIndex === false || endIndex === -1 || endIndex < beginIndex) {
                setMsg(`Invalid PEM encoded X509 certificate\n. A PEM encoded X509 certificate starts with ${PEM_CERT_BEGIN}, ends with ${PEM_CERT_END}`);
                return;
            }
            validCert = value.slice(beginIndex + PEM_CERT_BEGIN.length, endIndex);
        }
        setMsg("");
        return validCert.trim();
    }

    const handleFileUploadChange = (e) => {
        const value = e.target.files[0];
        if (value === "" || value === undefined) {
            setSelectedFile(null);
            setIsFileSelected(false);
            return;
        }
        setSelectedFile(value);
        setIsFileSelected(true);
    }

    return (
        <div>
            <Dialog
                open={assignCertDialogOpen}
                onClose={handleClose}
                PaperProps={{style: {borderRadius: 12, maxWidth: '800px'}}}
                TransitionComponent={Transition}
            >
                <DialogTitle color="white"
                             sx={{backgroundColor: "rgba(60,120,185,1)"}}
                >
                    Assign Certificate
                </DialogTitle>
                <DialogContent>
                    <StyledTypography>
                        Select a HISP
                    </StyledTypography>
                    <FormControl fullWidth sx={{marginBottom: 1}}>
                        <InputLabel id="hisps-label">Hisp</InputLabel>
                        <Select
                            labelId="hisps-label"
                            value={selectedHisp}
                            label='hisp'
                            onChange={handleHispChange}
                        >
                            {hisps?.length && hisps.map(h => (
                                <MenuItem
                                    key={h.hispId}
                                    value={h.hispName}
                                    onClick={() => setSelectedHispId(h.hispId)}
                                >
                                    {h.hispName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <StyledTypography>Please select certificate to upload</StyledTypography>
                    <label htmlFor="contained-button-file">
                        <Input accept=".pem,.crt,.csr,.der,.cer" id="contained-button-file" multiple type="file" style={{ display: 'none' }} onChange={handleFileUploadChange}/>
                        <Button variant="outlined" component="span" startIcon={<FileUploadIcon />}>
                            Choose File
                        </Button>&nbsp;
                        <span>{isFileSelected ? selectedFile.name : ''}</span>
                    </label>

                    <hr style={{marginBottom: 20, marginTop: 20}}/>

                    <StyledTypography>
                        Or paste the PEM encoded certificate below
                    </StyledTypography>
                    <TextareaAutosize
                        minRows={15}
                        placeholder={"-----BEGIN CERTIFICATE-----\n...\n...\n...\n-----END CERTIFICATE-----"}
                        style={{width: '750px'}}
                        value={cert}
                        onChange={handleCertChange}
                    />
                    {msg && <Alert severity='warning' sx={{mt: 1, mb: 1}}>{msg}</Alert>}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleUpload} variant='contained'>Upload</Button>
                    <Button onClick={handleClose} variant='outlined'>Cancel</Button>
                </DialogActions>
            </Dialog>
            <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg}/>
            <CustomBackdrop open={loading}/>
        </div>
    )
}
